<template>
    <div class="content-wrapper">
        <div v-if="$gate.isGreyManager()">
            <greyman-dash></greyman-dash>
        </div>
        <div v-if="$gate.isSysAdmin()">
            <sys-admin-dash></sys-admin-dash>
        </div>
        <div v-if="$gate.isMISAdmin()">
            <mis-admin-dash></mis-admin-dash>
        </div>
        <div v-if="$gate.isSecondaryMISAdmin()">
            <secondary-mis-admin-dash></secondary-mis-admin-dash>
        </div>
        <div v-if="$gate.isServiceAdmin()">
            <service-admin-dash></service-admin-dash>
        </div>
        <div v-if="$gate.isServiceManager()">
            <service-manager-dash></service-manager-dash>
        </div>
        <div v-if="$gate.isServiceTech()">
            <service-tech-dash></service-tech-dash>
        </div>
        <div v-if="$gate.isServiceAgent()">
            <service-agent-dash></service-agent-dash>
        </div>
        <div v-if="$gate.isCCManager()">
            <cc-manager-dash></cc-manager-dash>
        </div>
        <div v-if="$gate.isCCAgent()">
            <cc-agent-dash></cc-agent-dash>
        </div>
        <div v-if="$gate.isPurchaseManager()">
            <purchase-manager-dash></purchase-manager-dash>
        </div>
        <div v-if="$gate.isPurchaseAdmin()">
            <purchase-admin-dash></purchase-admin-dash>
        </div>
        <div v-if="$gate.isReplacementManager()">
            <replacement-manager-dash></replacement-manager-dash>
        </div>
        <div v-if="$gate.isDOAManager()">
            <doa-manager-dash></doa-manager-dash>
        </div>
        <div v-if="$gate.isBranchManager()">
            <branch-manager-dash></branch-manager-dash>
        </div>
        <div v-if="$gate.isBranchAccountant()">
            <branch-accountant-dash></branch-accountant-dash>
        </div>
        <div v-if="$gate.isZonalManager()">
            <zonal-manager-dash></zonal-manager-dash>
        </div>
        <div v-if="$gate.isWarehouseManager()">
            <warehouse-manager-dash></warehouse-manager-dash>
        </div>
        <div v-if="$gate.isUser()">
            <user-dash></user-dash>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        console.log("Dashboard Mounted");
    },
};
</script>
